/**
 * Returns the pixel height the motivation radar + bar charts should render
 * at, scaled to the number of motivations in the dataset. The bar chart needs
 * roughly `ROW_HEIGHT_PX` per motivation row to render its three grouped bars
 * (game design / live events / creatives) at a comfortable thickness; below
 * ~36px per row the bars start to read as hairlines stacked on top of each
 * other. The radar chart uses the same height so the two charts stay
 * vertically aligned in the side-by-side panel layout.
 *
 * A `MIN_HEIGHT_PX` floor keeps small datasets from collapsing the radar to
 * an awkwardly small polygon.
 */

const ROW_HEIGHT_PX = 40
const AXIS_AND_PADDING_PX = 64
const MIN_HEIGHT_PX = 500

export function getMotivationChartHeight(motivationCount: number): number {
  return Math.max(MIN_HEIGHT_PX, motivationCount * ROW_HEIGHT_PX + AXIS_AND_PADDING_PX)
}
